/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AttachmentGenerationState = 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';

export const AttachmentGenerationState = {
    IN_PROGRESS: 'IN_PROGRESS' as AttachmentGenerationState,
    COMPLETED: 'COMPLETED' as AttachmentGenerationState,
    FAILED: 'FAILED' as AttachmentGenerationState
};

